<template>
  <modal :title="title" title-border size="small" @close="emit('close')">
    <div class="divide-y divide-gray-200 text-sm" data-cy="confirm-modal-body">
      <div class="p-8">
        <slot></slot>
      </div>
      <div class="flex justify-end space-x-4 p-8">
        <input-button :variant="'muted'" @click="emit('close')">
          {{ $t("common.cancel") }}
        </input-button>
        <input-button
          :variant="confirmButtonVariant"
          data-cy="confirm-button"
          @click="emit('confirm')"
        >
          {{ confirmButtonText ?? $t("common.confirm") }}
        </input-button>
      </div>
    </div>
  </modal>
</template>

<script setup lang="ts">
import InputButton from "@/components/input/InputButton.vue";
import Modal from "@/components/shared/Modal.vue";
import type { InputButtonVariant } from "@/types/CommonTypes";

const emit = defineEmits<{
  close: [];
  confirm: [];
}>();

const { confirmButtonText, confirmButtonVariant = "primary" } = defineProps<{
  confirmButtonText?: string;
  confirmButtonVariant?: InputButtonVariant;
  title?: string;
}>();
</script>
